import { styled } from "~/common/mui";

export const makeExternallyStyledElement = <P>(element: React.JSXElementConstructor<P>) => {
  const StyledElement = styled(element, { shouldForwardProp: (prop) => prop !== "rootStyles" })<
    P & { rootStyles?: string }
  >(({ rootStyles }) => rootStyles);
  return StyledElement;
};

export const makeExternallyStyledBaseElement = <P extends keyof JSX.IntrinsicElements>(element: P) => {
  const StyledElement = styled(element, { shouldForwardProp: (prop) => prop !== "rootStyles" })<
    JSX.IntrinsicElements[P] & { rootStyles?: string }
  >(({ rootStyles }) => rootStyles);
  return StyledElement;
};
